import withPrivateRoute from '@/components/hoc/withPrivateRoute';
import { ROLES_PERMISSIONS } from '@/constants';
import ProjectDetailPage from './ProjectDetailPage';

function PrivateProjectDetail() {
  return <ProjectDetailPage />;
}

const ProjectDetail = withPrivateRoute(
  PrivateProjectDetail,
  ROLES_PERMISSIONS.TIME_TRACKING.VIEW
);

export default ProjectDetail;
